<template>
  <div>
    <file-upload />
    <br />
    <dropbox-selector @fileSelected="fileSelected" />
  </div>
</template>

<script>
import DropboxSelector from "@/components/DropboxSelector.vue";
import FileUpload from "@/components/FileUpload.vue";
import { mapGetters } from "vuex";
import asset from "../js/asset";

export default {
  components: {
    "file-upload": FileUpload,
    "dropbox-selector": DropboxSelector
  },
  computed: {
    ...mapGetters({ user: "user/user" })
  },
  methods: {
    fileSelected(fileData) {
      const newAsset = new asset.Asset({
        URL: fileData.URL,
        title: fileData.name,
        type: asset.AssetType.IMAGE,
        owners: [this.user.details.uid]
      });
      newAsset.fbSave();
    }
  }
};
</script>

